import { render } from "./menu.component.vue?vue&type=template&id=3c692f12"
import script from "./menu.component.vue?vue&type=script&lang=js"
export * from "./menu.component.vue?vue&type=script&lang=js"

import "./menu.component.vue?vue&type=style&index=0&id=3c692f12&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__